export default __webpack_public_path__ + "static/media/landing_sites.e7e07696.svg";